import React, { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import NavbarS2 from "../../components/NavbarS2/NavbarS2";
import Projects from "../../api/projects";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo-2.svg";
import psi1 from "../../images/recruitment1.png";
import psi2 from "../../images/recruitment2.png";
import psi3 from "../../images/recruitment3.png";
import psi4 from "../../images/recruitment4.png";
import psingle1 from "../../images/project-details/03.jpg";
import psingle2 from "../../images/project-details/04.jpg";
const decorationSvg = process.env.PUBLIC_URL + "/recruitment-decoration.svg";

const RecruitmentDetail = () => {
  const { slug } = useParams();
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="project-single-page section-padding">
      <div className="container">
        <div className="project-wrap" style={{ padding: "0" }}>
          <div className="project-top-info">
            <div className="row align-items-center">
              <div className="col-lg-8 col-12">
                <div className="section-title poort-text poort-in-right">
                  <h3
                    style={{
                      fontWeight: "700",
                      lineHeight: "140%",
                    }}
                  >
                    엠알메탈로는 잠재력있는 {window.innerWidth < 768 && <br />}{" "}
                    인재를 {window.innerWidth > 768 && <br />}
                    기다리고 있습니다.
                  </h3>
                  <h2
                    style={{
                      color: "#000",
                      fontWeight: "400",
                      marginBottom: "20px",
                    }}
                  >
                    엠알메탈로와 일하는 동료들은{" "}
                    {window.innerWidth < 768 && <br />} 이런 사람입니다.
                  </h2>
                </div>
              </div>
            </div>
            {/* 첫 번째 섹션: 이미지(왼쪽) + 텍스트(오른쪽) */}
            <div
              style={{
                display: "flex",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
                alignItems: "center",
                gap: window.innerWidth < 768 ? "24px" : "50px",
                marginBottom: "40px",
              }}
            >
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={psi1}
                  alt=""
                  style={{
                    width: "100%",
                    height: "auto",
                    // objectFit: "cover",
                  }}
                />
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "14px",
                      height: "14px",
                      borderRadius: "50%",
                      backgroundColor: "#004EA2",
                    }}
                  ></span>
                  <h2
                    className="poort-text poort-in-right"
                    style={{
                      margin: 0,
                      fontSize: window.innerWidth < 768 ? "22px" : "28px",
                      fontWeight: 600,
                      color: "#313337",
                    }}
                  >
                    우리는 기초, 기본에 충실합니다.
                  </h2>
                </div>
                <p
                  style={{
                    color: "#41444A",
                    fontSize: window.innerWidth < 768 ? "14px" : "17px",
                    lineHeight: "1.7",
                    margin: 0,
                  }}
                >
                  우리는 정도를 지키고, 고객의 이익을 최우선시하는 자세로
                  시장으로부터 신뢰를 획득하는 것을 목표로 합니다.
                </p>
              </div>
            </div>

            {/* 두 번째 섹션: 텍스트(왼쪽) + 이미지(오른쪽) */}
            <div
              style={{
                display: "flex",
                flexDirection:
                  window.innerWidth < 768 ? "column-reverse" : "row",
                alignItems: "center",
                gap: window.innerWidth < 768 ? "24px" : "50px",
                marginBottom: "40px",
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "14px",
                      height: "14px",
                      borderRadius: "50%",
                      backgroundColor: "#004EA2",
                    }}
                  ></span>
                  <h2
                    className="poort-text poort-in-right"
                    style={{
                      margin: 0,
                      fontSize: window.innerWidth < 768 ? "22px" : "28px",
                      fontWeight: 600,
                      color: "#313337",
                    }}
                  >
                    모두의 이익이 우리의 원동력입니다.
                  </h2>
                </div>
                <p
                  style={{
                    color: "#41444A",
                    fontSize: window.innerWidth < 768 ? "14px" : "17px",
                    lineHeight: "1.7",
                    margin: 0,
                  }}
                >
                  나와 팀의 이해를 넘어 모두의 이익을 위해 협력합니다. 조직
                  전체의 역량을 기반으로 개인의 발전을 지원하는 win-win 정신이
                  성장의 발판입니다.
                </p>
              </div>
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={psi2}
                  alt=""
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>

            {/* SVG 장식 요소 */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "40px 0",
              }}
            >
              <img
                src={decorationSvg}
                alt=""
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>

            {/* 세 번째/네 번째 섹션: 세로 배치 with border-left */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "28px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: window.innerWidth < 768 ? "column" : "row",
                  alignItems: window.innerWidth < 768 ? "flex-start" : "center",
                  gap: window.innerWidth < 768 ? "16px" : "40px",
                }}
              >
                <div
                  style={{
                    borderLeft: "3px solid #004EA2",
                    paddingLeft: "24px",
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <h2
                    className="poort-text poort-in-right"
                    style={{
                      margin: 0,
                      fontSize: window.innerWidth < 768 ? "20px" : "24px",
                      fontWeight: 600,
                      color: "#313337",
                    }}
                  >
                    자신의 일은 스스로 책임집니다.
                  </h2>
                </div>
                <p
                  style={{
                    color: "#41444A",
                    fontSize: window.innerWidth < 768 ? "14px" : "16px",
                    lineHeight: "1.7",
                    margin: 0,
                    flex: 1,
                  }}
                >
                  우리는 자율과 창의정신을 존중하며, 자신의 일에 대해서는 책임을
                  지는 High Performance, High Pay의 프로정신을 갖추고 있습니다.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: window.innerWidth < 768 ? "column" : "row",
                  alignItems: window.innerWidth < 768 ? "flex-start" : "center",
                  gap: window.innerWidth < 768 ? "16px" : "40px",
                }}
              >
                <div
                  style={{
                    borderLeft: "3px solid #004EA2",
                    paddingLeft: "24px",
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <h2
                    className="poort-text poort-in-right"
                    style={{
                      margin: 0,
                      fontSize: window.innerWidth < 768 ? "20px" : "24px",
                      fontWeight: 600,
                      color: "#313337",
                    }}
                  >
                    최고가 되기위해 끊임없이 도전합니다.
                  </h2>
                </div>
                <p
                  style={{
                    color: "#41444A",
                    fontSize: window.innerWidth < 768 ? "14px" : "16px",
                    lineHeight: "1.7",
                    margin: 0,
                    flex: 1,
                  }}
                >
                  우리에겐 사람이 곧 경쟁력 입니다. 우리는 모두 자기 분야에서
                  최고가 되기 위해 끊임없이 노력하는 도전정신이 필요합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentDetail;
